var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "un-start" }, [
    _c("img", { attrs: { src: _vm.emptyImg } }),
    _vm._v(" "),
    _c("div", { staticClass: "text" }, [_vm._v("投票稍后就来，感谢耐心等待")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }